import TrailersListContainer from "../../../components/asset-management/TrailersList";

export default function Trailers() {
  return <TrailersListContainer />;
}
